export default __webpack_public_path__ + "static/demo-phone-a17adbe598a688b807c53d4a53612a80.png";